(function () {
  'use strict';

  // Announcement bar rotation (mobile)
  var messages = ['WORLDWIDE SHIPPING', 'FREE SHIPPING OVER €150'];
  var annEl = document.getElementById('announcement-text');
  if (annEl) {
    var annIdx = 0;
    setInterval(function () {
      annIdx = (annIdx + 1) % messages.length;
      annEl.textContent = messages[annIdx];
    }, 4000);
  }

  // Mobile menu toggle
  var mobileBtn = document.getElementById('mobile-menu-btn');
  var mobileMenu = document.getElementById('mobile-menu');
  if (mobileBtn && mobileMenu) {
    mobileBtn.addEventListener('click', function () {
      var open = !mobileMenu.classList.contains('hidden');
      mobileMenu.classList.toggle('hidden', open);
      mobileBtn.textContent = open ? 'MENU' : 'CLOSE';
    });
  }
})();
